__turbopack_context__.v({
  "calloutBody": "EK-IcW_calloutBody",
  "calloutRoot": "EK-IcW_calloutRoot",
  "calloutText": "EK-IcW_calloutText",
});
